/**
 * Assert state which your program assumes to be true.
 *
 * @private
 * @param {boolean} condition State to assert.
 * @param {string} message Message to be thrown when not in production.
 * @returns {undefined}
 */
var invariant = function invariant(condition, message) {
  if (condition) {
    return;
  }
  var error = "LD: ".concat(message || 'unknown violation');
  if (process.env.NODE_ENV === 'production') {
    /* eslint-disable-next-line no-console */
    console.error(error);
  } else {
    throw new Error(error);
  }
};

export { invariant };
